import { type RumInitConfiguration } from "@datadog/browser-rum-core";

export const datadogRumConfig = {
  applicationId: "655783c1-1731-4e55-9495-3e7e7cd2a301",
  clientToken: "pub6b9d8e2085002efe3bbce5dc06e3a6ad",
  site: "datadoghq.eu",
  service: "dashboard",
  env: process.env.MODE,
  // The version is used for source map upload and version tag in the RUM explorer.
  version: process.env.APP_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "allow",
} as RumInitConfiguration;
